module.exports = __webpack_public_path__ + "img/notification.be79dca7.svg";